import React from 'react';

interface DevicesPaginationProps {
  page: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const PAGE_SIZES = [25, 50, 100, 250, 500];
const MAX_VISIBLE_PAGES = 5;

/** The page numbers around the current one, five at most. */
const visiblePages = (page: number, totalPages: number): number[] => {
  let start = Math.max(1, page - Math.floor(MAX_VISIBLE_PAGES / 2));
  const end = Math.min(totalPages, start + MAX_VISIBLE_PAGES - 1);
  if (end - start < MAX_VISIBLE_PAGES - 1) start = Math.max(1, end - MAX_VISIBLE_PAGES + 1);
  const pages: number[] = [];
  for (let i = start; i <= end; i += 1) pages.push(i);
  return pages;
};

/** The device list pager: range shown, rows per page, first / previous / numbers / next / last. */
export const DevicesPagination: React.FC<DevicesPaginationProps> = ({ page, totalPages, totalItems, pageSize, onPageChange, onPageSizeChange }) => (
  <div className="pagination-wrapper">
    <div className="pagination-info">
      <span>
        Showing {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, totalItems)} of {totalItems} devices
      </span>
      <div className="items-per-page">
        <label htmlFor="itemsPerPage">Items per page:</label>
        <select id="itemsPerPage" value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))} className="items-per-page-select">
          {PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
      </div>
    </div>

    {totalPages > 1 && (
      <div className="pagination">
        <button type="button" onClick={() => onPageChange(1)} disabled={page === 1} className="pagination-btn">First</button>
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page === 1} className="pagination-btn">Previous</button>
        <div className="page-numbers">
          {visiblePages(page, totalPages).map((n) => (
            <button key={n} type="button" onClick={() => onPageChange(n)} className={`page-btn ${n === page ? 'active' : ''}`}>{n}</button>
          ))}
        </div>
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page === totalPages} className="pagination-btn">Next</button>
        <button type="button" onClick={() => onPageChange(totalPages)} disabled={page === totalPages} className="pagination-btn">Last</button>
      </div>
    )}
  </div>
);
